import { Component, Input, OnChanges, OnInit, AfterViewInit, OnDestroy, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

// @ts-ignore: Suppress strict type checking for the local file import if types aren't available
// import * as CanvasJS from './canvasjs.stock.min';
import * as CanvasJS from "./canvasjs.stock.min.js"
// Note: Ensure the path above matches where you placed the file in your project

@Component({
  selector: 'app-spectra-chart',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="chart-wrapper">
      <div [id]="chartContainerId" style="height: 450px; width: 100%;"></div>
    </div>
  `
})
export class SpectraChartComponent implements AfterViewInit, OnChanges, OnDestroy {

  @Input() dataSeries: any[] = [];
  @Input() titleX: string = 'Frequency (Hz)';
  @Input() titleY: string = 'Amplitude (mm/s)';

  public chartContainerId = 'chartContainer-' + Math.floor(Math.random() * 10000);
  private chart: any;

  // ngAfterViewInit() {
  //   this.renderChart();
  // }

  ngOnChanges(changes: SimpleChanges) {
    // Re-render only if the chart instance exists and data has changed
    if (this.chart && changes['dataSeries']) {
      this.updateChart();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.dataSeries && this.dataSeries.length > 0) {
        this.renderChart();
      }
    }, 300);
  }


  renderChart() {
    // Basic Configuration
    const options = {
      theme: "light2", // "light1", "light2", "dark1", "dark2"
      animationEnabled: true, // Disabled for performance with high data density (FFT)
      zoomEnabled: true,
      exportEnabled: true,
      title: {
        text: ""
      },
      axisX: {
        title: this.titleX,
        titleFontSize: 14,
        labelFontSize: 12,
        crosshair: {
          enabled: true,
          snapToDataPoint: true
        },
        gridThickness: 1,
        gridColor: "#e0e0e0"
      },
      axisY: {
        title: this.titleY,
        titleFontSize: 14,
        labelFontSize: 12,
        includeZero: true,
        crosshair: {
          enabled: true
        },
        gridThickness: 1,
        gridColor: "#e0e0e0"
      },
      toolTip: {
        shared: true
      },
      legend: {
        cursor: "pointer",
        verticalAlign: "top",
        horizontalAlign: "center",
        dockInsidePlotArea: false,
        itemclick: (e: any) => {
          // Toggle visibility logic
          if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        }
      },
      data: this.dataSeries
    };

    // Initialize CanvasJS Chart
    // @ts-ignore
    this.chart = new CanvasJS.Chart(this.chartContainerId, options);
    this.chart.render();
  }

  updateChart() {
    this.chart.options.data = this.dataSeries;
    this.chart.render();
  }

  ngOnDestroy() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
